import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useWorkWithUs } from "contexts/WorkWithUs.contexts";

const useContact = () => {
    const { t: translate } = useTranslation();
    const {
        dataFields,
        errors,
        updateDataField,
        updateErrors,
        updateStatusError,
    } = useWorkWithUs();

    const handleChangeText = useCallback(
        ({ target }, item) => {
            updateDataField(item, {
                ...{ ...dataFields[item], [target.name]: target.value },
            });

            updateErrors(item, {
                ...{ ...errors[item], [target.name]: false },
            });
            updateStatusError(false);
        },
        [dataFields, errors, updateDataField, updateErrors, updateStatusError]
    );


    const origemContatoList = [
        { value: "Site Grupo Altum", label: "Site Grupo Altum" },
        { value: "Site Adservi", label: "Site Adservi" },
        { value: "Site Master Vigilância", label: "Site Master Vigilância" },
        { value: "Site Grupo Liberdade", label: "Site Grupo Liberdade" },
        { value: "Site 5 Estrelas", label: "Site 5 Estrelas" },
        { value: "Site Tecnoseg", label: "Site Tecnoseg" },
        { value: "Linkedin", label: "Linkedin" },
        { value: "Facebook", label: "Facebook" },
        { value: "Instagram", label: "Instagram" },
        { value: "Whatsapp", label: "WhatsApp" },
        { value: "Indicação", label: "Indicação" },
        { value: "Outros", label: "Outros" },
    ];

    const getOptionsGender = [
        {
            label: translate("workWithUs.form.step3.genderOptions.masculine"),
            value: "Masculino",
        },
        {
            label: translate("workWithUs.form.step3.genderOptions.feminine"),
            value: "Feminino",
        },
    ];

    const getOptionsSexualOrientation = [
        {
            label: translate("workWithUs.form.step3.sexualOrientationOptions.preferNotToSay"),
            value: "Prefiro não informar",
        },
        {
            label: translate("workWithUs.form.step3.sexualOrientationOptions.asexual"),
            value: "Assexual",
        },
        {
            label: translate("workWithUs.form.step3.sexualOrientationOptions.bisexual"),
            value: "Bissexual",
        },
        {
            label: translate("workWithUs.form.step3.sexualOrientationOptions.heterosexual"),
            value: "Heterosexual",
        },
         {
            label: translate("workWithUs.form.step3.sexualOrientationOptions.homosexual"),
            value: "Homossexual",
        },
        {
            label: translate("workWithUs.form.step3.sexualOrientationOptions.pansexual"),
            value: "Pansexual",
        },
        {
            label: translate("workWithUs.form.step3.sexualOrientationOptions.other"),
            value: "Outra orientação",
        },
    ];

    const getOptionsGenderExtra = [
        {
            label: translate("workWithUs.form.step3.sexualOrientationOptions.preferNotToSay"),
            value: "Prefiro não informar",
        },
        {
            label: translate("workWithUs.form.step3.genderExtraOptions.cisgenderWoman"),
            value: "Mulher cisgênero",
        },
        {
            label: translate("workWithUs.form.step3.genderExtraOptions.cisgenderMan"),
            value: "Homem cisgênero",
        },
        {
            label: translate("workWithUs.form.step3.genderExtraOptions.transgenderWoman"),
            value: "Mulher transgênero",
        },
        {
            label: translate("workWithUs.form.step3.genderExtraOptions.transgenderMan"),
            value: "Homem transgênero",
        },
        {
            label: translate("workWithUs.form.step3.genderExtraOptions.non-binary"),
            value: "Não binário",
        },
        {
            label: translate("workWithUs.form.step3.genderExtraOptions.other"),
            value: "Outra identidade",
        },
    ];

    return {
        origemContatoList,
        getOptionsGender,
        getOptionsSexualOrientation,
        getOptionsGenderExtra,
        dataFields,
        errors,
        translate,
        handleChangeText,

    };
};

export default useContact;
